import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=f4cd732e&"
import script from "./SessionCard.vue?vue&type=script&lang=js&"
export * from "./SessionCard.vue?vue&type=script&lang=js&"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=f4cd732e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports